<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Warning'}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
    <div>{{'Release is blocked because the frame configuration has been flagged as changed'}} </div>
    
    <div style="padding: 1%;">
      <div>
        <mat-radio-group  name="_frameFlagged" [(ngModel)]="frameFlagged" (change)="FrameFlagChange($event)" style="display: flex;flex-direction: column;">
          <mat-radio-button [value]="1">{{'It was set incorrectly and is now correct'}}</mat-radio-button>
          <mat-radio-button [value]="2">{{'The frame has been changed and I will perform a replace action'}}</mat-radio-button>
      </mat-radio-group>
      </div>
    </div>
  
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel'}}</button>
    <button mat-raised-button color="warn"   (click)="ChangeFlag()">
      <span class="button__text">{{'Continue'}}</span></button>

     
  </div>
</div>